import * as React from "react";
import type { SVGProps } from "react";
const SvgCalendarCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#calendar-check_svg__a)">
      <path d="M19.99 21H4.01C2.9 21 2 20.1 2 18.99V6.01C2 4.9 2.9 4 4.01 4h15.98C21.1 4 22 4.9 22 6.01v12.98c0 1.11-.9 2.01-2.01 2.01M4.01 6v12.99H20V6.01H4.01z" />
      <path d="M7 7c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1M17 7c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1M11 18c-.31 0-.61-.15-.8-.4l-3-4c-.33-.44-.24-1.07.2-1.4s1.07-.24 1.4.2l2.12 2.83 4.23-6.76a1.003 1.003 0 0 1 1.7 1.06l-5 8a.99.99 0 0 1-.81.47z" />
    </g>
    <defs>
      <clipPath id="calendar-check_svg__a">
        <path fill="#fff" d="M2 3h20v18H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCalendarCheck;
